<template>
  <div class="random_count_down_bg_content">
    <div class="card_panel">
      <div class="page-title">随机点名</div>
      <div class="body-wrapper">
        <div class="left-wrapper"
             :style="{ width: isInit || !selectStudents.length ? '100%' : '60%' }">
          <div class="random-tips">
            <div class="text"
                 v-if="isInit">请点击按钮进行随机点名</div>
            <div class="calling"
                 v-else-if="iscalling && students.length">
              <van-image round
                         width="220px"
                         height="220px"
                         class="user-image"
                         v-if="students[rIndex]"
                         :src="students[rIndex].profileimageurl" />
              <p class="name"
                 v-if="students[rIndex]">
                {{ students[rIndex].firstname }}
              </p>
            </div>
            <div class="calling"
                 v-else-if="
                !iscalling && selectStudents[selectStudents.length - 1]
              ">
              <van-image round
                         width="220px"
                         height="220px"
                         class="user-image"
                         :src="selectStudents[selectStudents.length - 1].profileimageurl" />
              <p class="name">
                {{ selectStudents[selectStudents.length - 1].firstname }}
              </p>
            </div>
          </div>
          <div class="btn">
            <van-button type="primary"
                        class="btn-random"
                        @click="banRandom"
                        round
                        v-if="!iscalling">开始随机点名</van-button>
            <van-button type="primary"
                        class="btn-random"
                        @click="banRandom"
                        v-else
                        round>结束随机点名</van-button>
          </div>
        </div>
        <div v-if="!isInit && selectStudents.length"
             class="right-wrapper">
          <p class="random-record">点名记录</p>
          <div class="user-wrapper">
            <div class="user-list"
                 v-for="(item, index) in selectStudents"
                 :key="index">
              <img :src="item.profileimageurl"
                   class="avatar" />
              <div class="userinfo">
                <div class="username">
                  {{ item.firstname }}
                </div>
                <div class="date">{{ item.date }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import course from "@/api/course/index";
import { formatDate } from "@/utils/index";
import "@vant/touch-emulator";
import { Row, Col, CountDown, Image, Dialog, Button, Toast } from "vant";
Vue.use(Row)
  .use(Col)
  .use(CountDown)
  .use(Image)
  .use(Toast)
  .use(Dialog)
  .use(Button);
// @ is an alias to /src
export default {
  data () {
    return {
      students: [],
      iscalling: false,
      isInit: true,
      rIndex: 0,
      timeValue: "",
      selectStudents: [],
    };
  },
  methods: {
    // 获取班级学生名单
    async getStudents () {
      console.warn("course", this.$store.state.course);
      let students = await course.getUsersByCourseid({
        params: { courseid: this.$store.state.course.courseId },
        loadingText: "正在获取班级学生列表",
        errorFn: this.handleError,
      });
      if (students) {
        this.students = students.map((v) => {
          return {
            id: v.id,
            firstname: v.firstname,
            lastname: v.lastname,
            fullname: v.fullname,
            profileimageurl: v.profileimageurl,
            profileimageurlsmall: v.profileimageurlsmall,
          };
        });
        console.log("students", this.students);
      }
    },
    // 投屏状态下禁止点击
    banRandom () {
      Dialog.alert({
        title: `温馨提示`,
        message: "投屏状态下请在手机端完成点名操作",
      }).then(() => { });
    },
    // 开始随机点名
    startRandom () {
      Toast.clear();
      const _this = this;
      console.log("开始点名", _this.students.length);
      clearInterval(this.timeValue);
      this.iscalling = true;
      this.isInit = false;
      this.timeValue = setInterval(() => {
        if (_this.students.length === 1) {
          _this.rIndex = 0;
        } else if (_this.students.length === 0) {
          clearInterval(_this.timeValue);
          // Toast("已经选完全部成员啦");
        } else {
          _this.rIndex = Math.floor(Math.random() * _this.students.length);
        }
      }, 120);
    },
    // 结束随机点名
    stopRandom (date = "", userid = "") {
      const _this = this;
      clearInterval(this.timeValue);
      this.iscalling = false;
      if (userid) {
        _this.rIndex = _this.students.findIndex((user) => user.id === userid);
        _this.students[_this.rIndex].date = date;
        if (_this.rIndex === -1) return false;
        console.log("phone");
      } else {
        console.log("pc");
        _this.students[_this.rIndex].date = formatDate(new Date());
      }
      console.log(this.rIndex);
      console.log(this.students.length);
      _this.selectStudents.push(_this.students[this.rIndex]);
      _this.students.splice(this.rIndex, 1);
    },
    async onmessage () {
      const _this = this;
      this.$root.$on("startCall", () => {
        _this.startRandom();
      }),
        this.$root.$on("stopCall", ({ date, userid }) => {
          _this.stopRandom(date, userid);
        });
    },
  },
  beforeDestroy () {
    this.$root.$off("stopCall");
  },
  created () {
    this.onmessage();
  },
  mounted () {
    Toast.clear();
    this.getStudents();
  },
};
</script>
<style lang="less" scoped>
.random_count_down_bg_content {
  height: 100%;
  padding: 50px 160px;
  z-index: 9;
  position: relative;
  .w100 {
    width: 100%;
  }
  .card_panel {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 48px;
    padding: 60px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }
  .page-title {
    font-size: 54px;
    font-weight: bold;
  }
  .body-wrapper {
    flex: 1;
    display: flex;
    flex-direction: row;
    max-height: calc(100% - 70px);
    .left-wrapper {
      display: flex;
      height: 100%;
      padding-bottom: 80px;
      flex-direction: column;
      justify-content: space-between;
      .random-tips {
        font-size: 36px;
        color: #a6a6a6;
        text-align: center;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .calling {
          .user-image {
            border: 10px solid rgba(50, 255, 181, 0.7);
            box-shadow: 0 0 8px 0 rgba(50, 255, 181, 0.5);
          }
          .name {
            color: #494949;
            font-size: 54px;
          }
        }
      }
      .btn {
        text-align: center;
        .btn-random {
          height: 80px;
          font-size: 32px;
          width: 300px;
          background-color: #37ab7e;
        }
      }
    }
    .right-wrapper {
      flex: 1;
      border-left: 1px solid #eee;
      padding-left: 60px;
    }
    .random-record {
      font-size: 36px;
      color: #333333;
      margin-bottom: 60px;
    }
    .user-wrapper {
      overflow-y: auto;
      max-height: 80%;
      .user-list {
        display: flex;
        margin-bottom: 30px;
        img {
          width: 80px;
          height: 80px;
          border-radius: 100%;
        }
        .userinfo {
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .username {
            font-size: 32px;
          }
          .date {
            font-size: 20px;
            color: #6c6c6c;
          }
        }
      }
    }
  }
}
</style>